import { SpaceService } from "@/services/space/space.service";
import SpaceUserService from "@/services/spaceUser/spaceUser.service";
import { UserInterface } from "@/resources/interfaces/userInterfaces";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { UsersService } from "@/services/users/users.service";
import { AuthService } from "@/services/auth/auth.service";
const _spaceService = new SpaceService();
const _spaceUsersService = new SpaceUserService();
const _authService = new AuthService();

const setUsersInSpaceAction = ({ commit }, payload) => {
  commit("setUsersInSpace", payload);
};
const setSpacesAvailableAction = ({ commit }, payload) => {
  commit("setSpacesAvailable", payload);
};

const setSpaceAction = ({ commit }, payload) => {
  commit("setSpace", payload);
};

const setSpaceNameAction = ({ commit }, payload) => {
  commit("setSpaceName", payload.name);
  commit("setWelcomeText", payload.welcomeText);
};

const setSpaceImageUpdateAction = ({ commit }, payload) => {
  commit("setSpaceImageUpdate", payload);
};

const addUsersInSpaceAction = ({ commit }, usersInSpace) => {
  commit("addUsersInSpace", usersInSpace);
};

const setUsersInDrawAction = ({ commit }, payload) => {
  commit("setUsersInDraw", payload);
};

const addUsersInDrawAction = ({ commit }, payload) => {
  commit("addUsersInDraw", payload);
};

const removeUsersInDrawAction = ({ commit }, payload) => {
  commit("removeUsersInDraw", payload);
};

const setAllUsersAction = ({ commit }, payload) => {
  commit("setAllUsers", payload);
};

const setSpacesAvailablePageAction = ({ commit }, payload) => {
  commit("setSpacesAvailablePage", payload);
};

const setLastPageSpacesAction = ({ commit }, payload) => {
  commit("setLastPageSpaces", payload);
};

const setUsersInSpacePageAction = ({ commit }, payload) => {
  commit("setUsersInSpacePage", payload);
};

const setLastPageUserAction = ({ commit }, payload) => {
  commit("setLastPage", payload);
};

const setRoomUpdateAction = ({ commit }, payload) => {
  commit("updateRoom", payload);
};

const changeMultiWebinarInStore = ({ commit }, payload) => {
  commit("changeMultiWebinarInStore", payload);
};

const setPosterAction = ({ commit }, payload) => {
  commit("updatePoster", payload);
};

const setSelectedSpaceCustomizeAction = ({ commit }, payload) => {
  commit("setSelectedSpaceCustomize", payload);
};

// ONLY FILLS THE ARRAY AFTER YOU ENTER
const setConnectedSuperSpaceIdsAction = ({ commit }, payload) => {
  commit("setConnectedSuperSpaceIds", payload);
};

const setConnectedUsersCounterAction = ({ commit }, payload) => {
  commit("setConnectedUsersCounter", payload);
};

const getSpacesAvailableAction = ({ commit }, { callback, callbackError }) => {
  _spaceService
    .getSpacesAvailable()
    .then((response) => {
      //commit("setSpacesAvailable", response.data);
      if (response.data.length > 0) {
        const spaceDefault = localStorage.getItem("space_default");
        const space = response.data;
        if (spaceDefault) {
          callback(spaceDefault);
          return;
        }
        //TODO se setea por defecto un espacio
        localStorage.setItem("space_default", space[0].id);
        callback(space[0].id);
      } else {
        const error = "logout";
        callbackError(error);
      }
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getSpacePaginateAction = (
  { commit, state },
  { id, name = null, callback, callbackError }
) => {
  _spaceService
    .getSpacesPaginate(id, state.spacesAvailablePage, name)
    .then((response) => {
      const data = response.data;
      if (name) {
        commit("addSpacesAvailable", data);
        callback(response.data);
      }
      if (state.spacesAvailablePage === 1) commit("setSpacesAvailable", data);
      else commit("addSpacesAvailable", data);
      if (
        state.spacesAvailablePage <=
        parseInt(response.headers["pagination-last-page"])
      )
        commit("setSpacesAvailablePage", state.spacesAvailablePage + 1);
      commit(
        "setLastPageSpaces",
        parseInt(response.headers["pagination-last-page"])
      );
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};
const getSpaceAction = ({ commit, rootGetters }, { spaceId, callback, callbackError }) => {
  _spaceService
    .getSpace(spaceId)
    .then((response) => {
      const localSpace = rootGetters["SpaceStore/getSpace"]
      if (!localSpace || (localSpace && localSpace.superSpace.id == response.data.id)) {
        commit("setSpace", response.data);
      }
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getSpaceByIdAction = (
  { commit },
  { spaceId, callback, callbackError = null }
) => {
  _spaceService
    .getSpace(spaceId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};
const getSpaceUsersAction = (
  { commit, state, dispatch },
  { superSpaceId, callback = null }
) => {
  _spaceUsersService
    .getSpacesUsers(superSpaceId, state.usersInSpacePage)
    .then(async (response) => {
      const users = response.data;
      if (state.usersInSpacePage === 1) commit("setUsersInSpace", users);
      else commit("addUsersInSpace", users);
      if (
        state.usersInSpacePage <=
        parseInt(response.headers["pagination-last-page"])
      )
        commit("setUsersInSpacePage", state.usersInSpacePage + 1);
      commit("setLastPage", parseInt(response.headers["pagination-last-page"]));
      commit(
        "setTotalUsersInSpace",
        parseInt(response.headers["pagination-total-items"])
      );
      callback();
    })
    .catch((error) => {
      console.log(error);
    });
};

const getSpacesUsersByOrderNameAndLastNameAction = (
  { commit },
  { superSpaceId, page, callback, callbackError }
) => {
  _spaceUsersService
    .getSpacesUsersByOrderNameAndLastName(superSpaceId, page)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getSpacesUsersByOrderNameAndLastNameNoGuestAction = (
  { commit },
  { superSpaceId, page, callback, callbackError }
) => {
  _spaceUsersService
    .getSpacesUsersByOrderNameAndLastNameNoGuest(superSpaceId, page)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const sendReserveRoomAction = (
  { commit },
  { roomId, data, callback, callbackError }
) => {
  _spaceUsersService
    .setReserveRoom(roomId, data)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getRoomReservationsAction = (
  { commit },
  { roomId, date, callback, callbackError }
) => {
  _spaceUsersService
    .getRoomReservations(roomId, date)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getReserveAction = (
  { commit },
  { reserveId, callback, callbackError }
) => {
  _spaceUsersService
    .getReserve(reserveId)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const removeReserveAction = (
  { commit },
  { reserveId, callback, callbackError }
) => {
  _spaceUsersService
    .removeReserve(reserveId)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const updateReserveAction = (
  { commit },
  { reserveId, data, callback, callbackError }
) => {
  _spaceUsersService
    .updateReserve(reserveId, data)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getSpaceReservationsAction = (
  { commit },
  { spaceId, callback, callbackError }
) => {
  _spaceUsersService
    .getSpaceReservations(spaceId)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getUsersAction = (
  { commit },
  { spaceId, page, search, permissions, callback, callbackError }
) => {
  _spaceUsersService
    .getUsers(spaceId, page, search, permissions)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const searchSpaceUserAndNotAddAction = (
  { commit },
  { superSpaceId, name, page, callback, callbackError }
) => {
  _spaceUsersService
    .searchSpaceUser(superSpaceId, name, page)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};
const searchSpaceUserAction = (
  { commit },
  { superSpaceId, name, callback }
) => {
  _spaceUsersService
    .searchSpaceUser(superSpaceId, name, null)
    .then(async (response) => {
      const users = response.data;
      commit("addUsersInSpace", users);
      callback(response.data);
    })
    .catch((error) => {
      console.log(error);
      callback();
    });
};

const searchUserTagAction = (
  { commit },
  { superSpaceId, type, search, callback }
) => {
  _spaceUsersService
    .searchUserTag(superSpaceId, type, search)
    .then(async (response) => {
      const users = response.data;
      commit("addUsersInSpace", users);
      callback(response.data);
    })
    .catch((error) => {
      callback();
    });
};

/* const getAllUsersAction = (
  { commit, state, dispatch },
  { spaceId, callback }
) => {
  _spaceUsersService
    .getAllSpacesUser(spaceId)
    .then(async (response) => {
      const users = response.data;
      commit("setAllUsers", users);
      callback(response);
    })
    .catch((error) => {
      console.log(error);
    });
}; */

const getOnlyUsersOnlineAction = (
  { commit },
  { spaceId, callback, callbackError }
) => {
  _spaceUsersService
    .getUsersOnlineInSpace(spaceId)
    .then((response) => {
      /* const users = response.data.map((a) => {
        return {
          connectionStatus: a.superSpaceUser.connectionStatus,
          enabled: a.superSpaceUser.enabled,
          id: a.superSpaceUser.id,
          user: {
            availableStatus: a.superSpaceUser.user.availableStatus,
            availableStatusReason: a.superSpaceUser.user.availableStatusReason,
            id: a.superSpaceUser.user.id,
            lastName: a.superSpaceUser.user.lastName,
            name: a.superSpaceUser.user.name,
            profileImage: a.superSpaceUser.user.profileImage,
            timezone: a.superSpaceUser.user.timezone,
          },
        };
      });
      commit("addUsersInSpace", users); */
      commit("setUsersInDraw", response.data);
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getSpaceUsersOnlineAction = (
  { commit },
  { spaceId, callback, callbackError }
) => {
  _spaceUsersService
    .getUsersOnlineInSpace(spaceId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getSceneTypesAction = ({ commit }, { spaceType, superSpaceId, callback }) => {
  _spaceService
    .getSceneTypes(spaceType, superSpaceId)
    .then((response) => {
      commit("setSceneTypes", response.data);
      callback(response.data[0]);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getScenesTypesAction = ({ commit }, { spaceType, superSpaceId, callback, callbackError }) => {
  _spaceService
    .getSceneTypes(spaceType, superSpaceId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const updateSpaceAction = (
  { commit, rootGetters },
  { spaceId, payload, callback, callbackError }
) => {
  _spaceService
    .updateSpace(spaceId, payload)
    .then((response) => {
      const localSpace = rootGetters["SpaceStore/getSpace"]
      if (localSpace && localSpace.superSpace.id == response.data.id) {
        commit("setSpace", response.data);
      }
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error.response);
      console.log(error);
    });
};

const updateSceneAction = ({ commit }, { spaceId, data, callback }) => {
  _spaceService
    .updateScene(spaceId, data)
    .then((response) => callback())
    .catch((error) => {
      console.log(error);
    });
};

const updateRoomAction = (
  { commit },
  { roomId, data, callback, callbackError }
) => {
  _spaceService
    .updateRoomInfo(roomId, data)
    .then((response) => {
      commit("updateRoom", response.data);
      callback();
    })
    .catch((error) => {
      callbackError(error);
    });
};

const updatePosterAction = (
  { commit },
  { id, data, callback, callbackError }
) => {
  _spaceService
    .updatePoster(id, data)
    .then((response) => {
      commit("updatePoster", response.data);
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getRoomAction = ({ commit }, { roomId, callback, callbackError }) => {
  _spaceService
    .getRoom(roomId)
    .then((response) => {
      commit("updateRoom", response.data);
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getPosterAction = ({ commit }, { id, callback, callbackError }) => {
  _spaceService
    .getPoster(id)
    .then((response) => {
      commit("updatePoster", response.data);
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};
const getRoomGrazingAction = (
  { commit },
  { roomId, callback, callbackError }
) => {
  _spaceService
    .getRoom(roomId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const uploadSceneFileAction = (
  { commit },
  { data, callback, callbackError }
) => {
  _spaceService
    .uploadSceneFile(data)
    .then((response) => callback(response))
    .catch((error) => {
      callbackError(error);
    });
};

const uploadSpaceFileAction = (
  { commit },
  { data, callback, callbackError }
) => {
  _spaceService
    .uploadSpaceFile(data)
    .then((response) => callback(response.data))
    .catch((error) => {
      callbackError(error);
    });
};

const uploadRoomFileAction = ({ commit }, { data, callback, callbackError }) => {
  _spaceService
    .updateRoomImage(data)
    .then((response) => callback(response.data))
    .catch((error) => {
      callbackError(error);
    });
};

const uploadPosterFileAction = ({ commit }, { data, callback, callbackError }) => {
  _spaceService
    .updatePosterImage(data)
    .then((response) => callback(response.data))
    .catch((error) => {
      callbackError(error)
    });
};
const setUserOnlineAction = ({ commit, state }, payload) => {
  const user = payload;
  const usersInSpace = [...state.usersInSpace];
  const userUpdate = usersInSpace.filter((a) => a.id === user.id);
  if (userUpdate.length > 0) {
    const index = state.usersInSpace.findIndex((a) => a.id === user.id);
    usersInSpace.splice(index, 1, user);
  } else {
    usersInSpace.push(user);
  }
  commit("setUsersInSpace", usersInSpace);
};

const sendConsoleMessageAction = (
  { commit, state },
  { spaceId, data, callback }
) => {
  _spaceService
    .sendConsoleMessage(spaceId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => console.log(error));
};

const sendConsoleMessageMultiSpaceAction = (
  { commit, state },
  { superSpaceId, data, callback }
) => {
  _spaceService
    .sendConsoleMessageMultiSpace(superSpaceId, data)
    .then((response) => {
      callback();
    })
    .catch((error) => console.log(error));
};

const sendInfoUserAction = (
  { commit },
  { spaceId, userId, callback, callbackError }
): void => {
  _spaceService
    .sendInfoUser(spaceId, userId)
    .then(() => {
      callback();
    })
    .catch((error) => {
      callbackError();
    });
};

const activeSpaceAction = ({ commit }, { token, callback, callbackError }) => {
  _spaceService
    .activeSpace(token)
    .then((response) => {
      if (response.data.goToSpaceId) {
        localStorage.setItem(
          "space_default",
          response.data.goToSpaceId.toString()
        );
        localStorage.setItem("city", "OFF");
      }
      if (response.data.token) {
        _authService.decodeJwt(response.data);
      }
      callback(response);
    })
    .catch((error) => callbackError());
};

const generateInvitationSpaceAction = (
  { commit },
  { spaceId, callback, callbackError }
) => {
  _spaceService
    .generateUrlInvitation(spaceId)
    .then((response) => {
      commit("setSpace", response.data);
      callback(response.data);
    })
    .catch((error) => callbackError());
};

const generateUserInvitationSpaceAction = (
  { commit },
  { spaceId, callback, callbackError }
) => {
  _spaceService
    .generateUserUrlInvitation(spaceId)
    .then((response) => {
      commit("setSpace", response.data);
      callback(response.data);
    })
    .catch((error) => callbackError());
};

const deleteSpaceAction = ({ commit }, { spaceId, callback }) => {
  _spaceService
    .deleteSpace(spaceId)
    .then((response) => {
      commit("deleteSpaceAvailable", spaceId);
      callback();
    })
    .catch((error) => console.log(error));
};

const enableOrDisabledSpaceBySuperAdminAction = (
  { commit },
  { spaceId, payload, callback }
) => {
  _spaceService
    .enabledOrDisabledSpaceBySuperAdmin(spaceId, payload)
    .then((response) => {
      commit("updateSpaceAvailable", response.data);
      callback(response.data);
    })
    .catch((error) => console.log(error));
};

const enableOrDisabledSpaceAction = (
  { commit },
  { spaceId, payload, callback }
) => {
  _spaceService
    .enabledOrDisabledSpace(spaceId, payload)
    .then((response) => {
      commit("updateSpaceAvailable", response.data);
      callback(response.data);
    })
    .catch((error) => console.log(error));
};
const getRequestSpacesAction = ({ commit }, { page, callback }) => {
  _spaceService
    .getRequestSpaces(page)
    .then((response) => {
      callback(response);
    })
    .catch((error) => console.log(error));
};

const removeUserInSpace = ({ commit, state }, payload) => {
  const index = state.usersInSpace.findIndex((a) => a.id === payload.id);
  if (index >= 0) {
    state.usersInSpace.splice(index, 1);
  }
};

const updateImageUserInSpace = ({ commit, state }, user) => {
  const index = state.usersInSpace.findIndex((a) => a.user.id === user.id);
  const newUser = state.usersInSpace[index];

  const userMap = {
    availableStatus: user.availableStatus,
    availableStatusReason: user.availableStatusReason,
    id: user.id,
    lastName: user.lastName,
    name: user.name,
    profileImage: user.profileImage,
    timezone: user.timezone,
    workInOffice: user.workInOffice,
  };

  if (newUser) {
    newUser.user = userMap;
    state.usersInSpace.splice(index, 1, newUser);
    commit("setUsersInSpace", state.usersInSpace);
  }
};

const updateUserInSpace = ({ commit, state }, user) => {
  const index = state.usersInSpace.findIndex((a) => a.id === user.id);
  const newUser = state.usersInSpace[index];
  let userMap = null;
  if (user.availableStatus)
    userMap = {
      availableStatus: user.availableStatus,
      availableStatusReason: user.availableStatusReason,
      id: user.id,
      lastName: user.lastName,
      name: user.name,
      profileImage: user.profileImage,
      timezone: user.timezone,
      workInOffice: user.workInOffice,
    };
  else
    userMap = {
      availableStatus: user.user.availableStatus,
      availableStatusReason: user.user.availableStatusReason,
      id: user.user.id,
      lastName: user.user.lastName,
      name: user.user.name,
      profileImage: user.user.profileImage,
      timezone: user.user.timezone,
      workInOffice: user.user.workInOffice,
    };

  if (newUser) {
    newUser.user = userMap;
    state.usersInSpace.splice(index, 1, newUser);
    commit("setUsersInSpace", state.usersInSpace);
  }
};

const updateUserInSpaceList = ({ commit, state }, payload) => {
  const index = state.usersInSpace.findIndex(
    (a) => a.user.id === payload.user.id
  );
  if (index >= 0) {
    state.usersInSpace.splice(index, 1, payload);
    commit("setUsersInSpace", state.usersInSpace);
  }
};

const updateSpaceUser = ({ commit, state }, user: SpaceUserInterface) => {
  const index = state.usersInSpace.findIndex((a) => a.user.id === user.id);
  state.usersInSpace.splice(index, 1, user);
  commit("setUsersInSpace", state.usersInSpace);
};

const updateUsersInDrawAction = ({ commit, state }, payload) => {
  const index = state.usersInDraw.findIndex((a) => a.id === payload.id);
  state.usersInDraw.splice(index, 1, payload);
  commit("setUsersInDraw", state.usersInDraw);
};

const updateAllUsers = ({ commit, state }, user: SpaceUserInterface) => {
  const index = state.allUsers.findIndex((a) => a.id === user.id);
  state.allUsers.splice(index, 1, user);
  commit("setAllUsers", state.allUsers);
};

const getGlobalParamsAction = (
  { commit, state },
  { callback, callbackError }
) => {
  _spaceService
    .getGlobalParams()
    .then((response) => callback(response))
    .catch((error) => callbackError(error));
};

const sendEmojiReactionAction = async (
  { commit, state },
  { spaceId, data }
) => {
  _spaceService
    .sendEmojiReaction(spaceId, data)
    .then((response) => {
      // do nothing
    })
    .catch((error) => {
      // do nothing
    });
};

const createSpaceAction = ({ commit }, { data, callback }) => {
  _spaceService
    .createNewSpace(data)
    .then((response) => callback(response.data))
    .catch((error) => console.log(error));
};

const changeRoomPinAction = ({ commit }, { roomId, data, callback }) => {
  _spaceService
    .changeRoomPin(roomId, data)
    .then((response) => {
      commit("updateRoom", response.data);
      callback(response.data);
    })
    .catch((error) => console.log(error));
};

const removeAllPinSpaceAction = ({ commit }, { spaceId, callback }) => {
  _spaceService
    .removeAllPin(spaceId)
    .then((response) => callback(response.data))
    .catch((error) => console.log(error));
};

const addToFavouriteAction = ({ commit }, { spaceId, data, callback, callbackError }) => {
  _spaceService
    .addToFavourite(spaceId, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      callbackError(error);
    })
};

const getFavouriteSpacesAction = ({ commit }, { page, callback, callbackError }) => {
  _spaceService
    .getFavouriteSpaces(page)
    .then((response) => {
      commit("setFavouriteSpaces", response.data);
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const updateRoomNotesAction = ({ commit }, { roomId, data, callback, callbackError }) => {
  _spaceService
    .updateRoomNotes(roomId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getRoomNotesAction = ({ commit }, { roomId, pin, callback, callbackError }) => {
  _spaceService
    .getRoomNotes(roomId, pin)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const removeImageSpaceAction = ({ commit }, { imageId, callback, callbackError }) => {
  _spaceService
    .removeImageSpace(imageId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const removeImagePosterAction = ({ commit }, { imageId, callback, callbackError }) => {
  _spaceService
    .removeImagePoster(imageId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const removeImageRoomAction = ({ commit }, { imageId, callback, callbackError }) => {
  _spaceService
    .removeImageRoom(imageId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createByTeamsAction = ({ commit }, { data, callback, callbackError }) => {
  _spaceService
    .createByTeams(data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getGroupAction = ({ commit }, { superSpaceId, callback, callbackError }) => {
  _spaceService
    .getGroups(superSpaceId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const createGroupAction = ({ commit }, { superSpaceId, data, callback, callbackError }) => {
  _spaceService
    .createGroup(superSpaceId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const editGroupAction = ({ commit }, { groupId, data, callback, callbackError }) => {
  _spaceService
    .editGroup(groupId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const removeGroupAction = ({ commit }, { groupId, callback, callbackError }) => {
  _spaceService
    .removeGroup(groupId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getUsersGroupAction = ({ commit }, { groupId, callback, callbackError }) => {
  _spaceService
    .getUsersGroup(groupId)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const setUsersGroupAction = ({ commit }, { groupId, data, callback, callbackError }) => {
  _spaceService
    .setUsersGroup(groupId, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getSpacePhysicalReservationsAction = (
  { commit },
  { superSpaceId, callback, callbackError }
) => {
  _spaceUsersService
    .getSpacePhysicalReservations(superSpaceId)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const setReservePhysicalRoomAction = (
  { commit },
  { roomId, data, callback, callbackError }
) => {
  _spaceUsersService
    .setReservePhysicalRoom(roomId, data)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getPhysicalRoomReservationsAction = (
  { commit },
  { roomId, date, callback, callbackError }
) => {
  _spaceUsersService
    .getPhysicalRoomReservations(roomId, date)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const getPhysicalReserveAction = (
  { commit },
  { reserveId, callback, callbackError }
) => {
  _spaceUsersService
    .getPhysicalReserve(reserveId)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const removePhysicalReserveAction = (
  { commit },
  { reserveId, callback, callbackError }
) => {
  _spaceUsersService
    .removePhysicalReserve(reserveId)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

const updatePhysicalReserveAction = (
  { commit },
  { reserveId, data, callback, callbackError }
) => {
  _spaceUsersService
    .updatePhysicalReserve(reserveId, data)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};
const getAllSpacesAction = (
  { commit },
  { superSpaceId, callback, callbackError }
) => {
  _spaceService
    .getAllSpaces(superSpaceId, 1)
    .then(async (response) => {
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};

export default {
  getSpacesAvailableAction,
  getSpaceAction,
  getSpaceUsersAction,
  setUserOnlineAction,
  updateUserInSpace,
  getOnlyUsersOnlineAction,
  addUsersInSpaceAction,
  getSceneTypesAction,
  updateSpaceAction,
  updateSceneAction,
  setSpaceAction,
  uploadSceneFileAction,
  updateSpaceUser,
  updateRoomAction,
  uploadRoomFileAction,
  sendConsoleMessageAction,
  uploadSpaceFileAction,
  setUsersInSpaceAction,
  setAllUsersAction,
  activeSpaceAction,
  searchSpaceUserAction,
  updateAllUsers,
  generateInvitationSpaceAction,
  generateUserInvitationSpaceAction,
  setSpaceNameAction,
  setSpaceImageUpdateAction,
  getGlobalParamsAction,
  getSpacePaginateAction,
  setSpacesAvailablePageAction,
  setLastPageSpacesAction,
  getRoomAction,
  sendEmojiReactionAction,
  getUsersAction,
  deleteSpaceAction,
  enableOrDisabledSpaceBySuperAdminAction,
  getRequestSpacesAction,
  setUsersInSpacePageAction,
  setLastPageUserAction,
  createSpaceAction,
  getScenesTypesAction,
  sendConsoleMessageMultiSpaceAction,
  setSpacesAvailableAction,
  changeRoomPinAction,
  removeAllPinSpaceAction,
  setRoomUpdateAction,
  getSpaceByIdAction,
  enableOrDisabledSpaceAction,
  searchSpaceUserAndNotAddAction,
  getRoomGrazingAction,
  changeMultiWebinarInStore,
  getPosterAction,
  uploadPosterFileAction,
  updatePosterAction,
  setPosterAction,
  setUsersInDrawAction,
  addUsersInDrawAction,
  removeUsersInDrawAction,
  updateUserInSpaceList,
  removeUserInSpace,
  updateUsersInDrawAction,
  sendInfoUserAction,
  addToFavouriteAction,
  getFavouriteSpacesAction,
  updateRoomNotesAction,
  getRoomNotesAction,
  searchUserTagAction,
  removeImageSpaceAction,
  removeImagePosterAction,
  removeImageRoomAction,
  createByTeamsAction,
  updateImageUserInSpace,
  getSpaceUsersOnlineAction,
  createGroupAction,
  getGroupAction,
  editGroupAction,
  removeGroupAction,
  getUsersGroupAction,
  getSpacesUsersByOrderNameAndLastNameAction,
  setUsersGroupAction,
  sendReserveRoomAction,
  getSpaceReservationsAction,
  getRoomReservationsAction,
  getReserveAction,
  removeReserveAction,
  updateReserveAction,
  getSpacesUsersByOrderNameAndLastNameNoGuestAction,
  getSpacePhysicalReservationsAction,
  setReservePhysicalRoomAction,
  getPhysicalRoomReservationsAction,
  getPhysicalReserveAction,
  removePhysicalReserveAction,
  updatePhysicalReserveAction,
  setSelectedSpaceCustomizeAction,
  getAllSpacesAction,
  setConnectedSuperSpaceIdsAction,
  setConnectedUsersCounterAction,
};
